import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Table from "react-bootstrap/Table"
import "datatables.net-dt/css/dataTables.dataTables.min.css"
import DataTable from "datatables.net-dt/js/dataTables.dataTables.min.js"
import Button from '@mui/material/Button';
import adminStyles from './adminStyles.module.css'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { NavLink } from 'react-router-dom'
const BookAppointmentData = () => {
     const[data,setData]=useState([])
     const[appointments, setAppointments] = useState({});
     const[loading,setLoading] = useState(true);
     const[error, setError] = useState(null);
   useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/bookappointment`)
    .then((res)=>{
      setData(res.data)
    })
    .catch((err)=>{
      alert("Error Fetching Book Appointment Data")
    })
    setTimeout(()=>{
          new DataTable('#serviceTable');

    },1000)
  })
  useEffect(() => {
    fetchAppointments();
  }, []);

    const fetchAppointments = async () => {
        setLoading(true);
    try {
      const response = await axios.get('https://backendsurgylife-1.onrender.com/bookappointment');
      setAppointments(response.data.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch appointments');
      setLoading(false);
    }
  };

  const updateStatus = async (id, newStatus) => {
    try {
      await axios.put(`https://backendsurgylife-1.onrender.com/bookappointment/${id}`, { status: newStatus });
      fetchAppointments(); // Refresh the list
    } catch (err) {
      alert('Failed to update status');
    }
  };


  return (
  <main>    
        <section>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                           <Table striped bordered hover id='serviceTable'>
                    <thead>
                    <tr>
                                             <th>Patient Name</th>

                       <th>Treatment Name</th>
                       <th>Doctor Name</th>
                        <th>Patient Phone</th>
                       <th>Patient Email</th>
                       <th>Patient Location</th>
                       <th>Patient Message</th>
                       <th>Status</th>
                       <th>Action</th>

                    </tr>
                 </thead>

                     <tbody>
                            {
                              data.map((bookappointment)=>{
                                return(
                                    <tr key={bookappointment._id}>
                                          <td>{bookappointment.pname}</td>

                                        <td>{bookappointment.trname}</td>
                                        <td>{bookappointment.dname}</td>
                                        <td>{bookappointment.pphone}</td>
                                        <td>{bookappointment.pemail}</td>
                                        <td>{bookappointment.plocation}</td>
                                        <td>{bookappointment.pmessage}</td>
                                            
{/* 
                                              <td className='d-flex  justify-content-center  '>
      <Button variant="contained" color='error' className='me-3' onClick={()=>{deleteappintmentData(bookappointment._id)}}>
        <DeleteIcon/>
      </Button>


      <Button 
                       variant="outlined"
                        color='success'
                       >
                        <NavLink to={`/editappointment/${bookappointment._id}`}>
                                <EditIcon/>
                        </NavLink>
               
                          </Button>

                </td> */}
                 
                <td>
                  <select 
                    value={bookappointment.status} 
                    onChange={(e) => updateStatus(bookappointment._id, e.target.value)}
                    className={adminStyles.statusSelect}
                  >
                    <option value="pending">Pending</option>
                    <option value="confirmed">Confirmed</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="completed">Completed</option>
                  </select>
                </td>
                   <td>
                  <span className={`${adminStyles.status} ${adminStyles[bookappointment.status]}`}>
                    {bookappointment.status}
                  </span>
                </td>
                                    </tr>
                                )
                              })
                            }
                    </tbody>

                 </Table> 
    
                 </div>
             
                </div>
           
            </div>

        </section>
        
    </main>  )
}

export default BookAppointmentData
